module.exports = __webpack_public_path__ + "img/024-storm-19.83bbc14e.svg";